module.exports = {"TXTWCL_24_hour_lockout":{"id":"TXTWCL_24_hour_lockout","defaultMessage":"停玩24小时"}}